/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ClockFiveSolidV6 = (props) => (
  <Icon {...props} name="Clock Five Solid V6">
    <path d="M0 8c0-4.419 3.581-8 8-8s8 3.581 8 8c0 4.419-3.581 8-8 8s-8-3.581-8-8zm8.75-4.25C8.75 3.334 8.416 3 8 3s-.75.334-.75.75V8c0 .147.044.294.125.416l2 3a.723.723 0 0 0 1.041.181.687.687 0 0 0 .181-1.012L8.75 7.772V3.75z" />
  </Icon>
);

export default ClockFiveSolidV6;
